module.exports = __webpack_public_path__ + "img/XK.3435ff74.png";